<template>
  <div class="fill-height">
    <AuthWindow @afterLogin="afterLogin"/>
  </div>
</template>

<script>
import AuthWindow from "@/components/Auth/AuthWindow";

export default {
  components: {AuthWindow},
  methods: {
    afterLogin() {
      if (this.$route.query.afterLogin) {
        this.$router.push({name: this.$route.query.afterLogin})
      } else {
        this.$router.push({name: "dashboard"})
      }
    }
  },
  mounted() {
    const therapistId = this.$route.query.assign_therapist
    if (therapistId) {
      localStorage.setItem('assign_therapist', therapistId)
    }
  }
}
</script>

<style scoped>

</style>